import strings from '../i18n/strings';
import { SEASON_END_DATE } from '../lib/constants';
import { isDateAfter } from '../lib/date';
import { combineReducers } from '../lib/imports';

const leaderboardData = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      return action.resp;
    case 'FETCH_LEADERBOARD_FAILURE':
      return {};
    default:
      return state;
  }
};

const isCurrentlySeason = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_SEASON_STATUS_SUCCESS':
      return action.resp;
    case 'FETCH_SEASON_STATUS_FAILURE':
      return false;
    default:
      return state;
  }
};

const isCurrentlyPlayoffs = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYOFFS_STATUS_SUCCESS':
      return action.resp;
    case 'FETCH_PLAYOFFS_STATUS_FAILURE':
      return false;
    default:
      return state;
  }
};

const localLeaderboardData = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
      return action.resp;
    case 'FETCH_LOCAL_LEADERBOARD_FAILURE':
      return {};
    default:
      return state;
  }
};

const error = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      return false;
    case 'FETCH_LEADERBOARD_FAILURE':
      return true;
    default:
      return state;
  }
};

const currentChallenge = (state = 1, action) => {
  const seasonEnded = isDateAfter(SEASON_END_DATE);
  const maxChallenges = strings['challenges/dates'].en.length;

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS': {
      const challengeCount = Object.keys(action.resp?.challenges ?? {}).length;
      if (!challengeCount) {
        return state;
      }
      if (seasonEnded && challengeCount > maxChallenges) {
        return maxChallenges;
      }
      return challengeCount;
    }
    default:
      return state;
  }
};

const isLoading = (state = true, action) => {
  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
    case 'FETCH_LEADERBOARD_FAILURE':
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
    case 'FETCH_LOCAL_LEADERBOARD_FAILURE':
    case 'FETCH_PLAYOFFS_STATUS_SUCCESS':
    case 'FETCH_PLAYOFFS_STATUS_FAILURE':
      return false;
    case 'FETCH_LEADERBOARD_START':
    case 'FETCH_LOCAL_LEADERBOARD_START':
      return true;
    default:
      return state;
  }
};

const challengeErrorCode = (state = '', action) => {
  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      if (action.resp.totalDaysCompleted === 0) {
        return 'leaderboard/error/no-completed-days';
      }
      return '';
    default:
      return state;
  }
};

const hasUserStats = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      return true;
    case 'FETCH_USER_STATS_START':
      return false;
    default:
      return state;
  }
};

const userStats = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const selectedChallenge = (state = null, action) => {
  switch (action.type) {
    case 'SET_CHALLENGE_NUMBER':
      return action.resp;
    case 'FETCH_LEADERBOARD_SUCCESS':
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
      if (action.resp.status === 'current' && action.resp.board === 'monthly' && !state) {
        return action.resp.challengeNumber;
      }
      return state;
    case 'SET_MENU_LINK_CLICK':
      return null;
    default:
      return state;
  }
};

const selectedBoard = (state = 'season', action) => {
  switch (action.type) {
    case 'SET_BOARD_VIEW':
      return action.resp;
    default:
      return state;
  }
};

export default combineReducers({
  leaderboardData,
  isCurrentlySeason,
  isCurrentlyPlayoffs,
  localLeaderboardData,
  currentChallenge,
  isLoading,
  challengeErrorCode,
  error,
  userStats,
  hasUserStats,
  selectedChallenge,
  selectedBoard,
});
